import { render, staticRenderFns } from "./newSector.vue?vue&type=template&id=650ea28a&scoped=true"
import script from "./newSector.vue?vue&type=script&lang=js"
export * from "./newSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650ea28a",
  null
  
)

export default component.exports